import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import PrintIcon from '@material-ui/icons/Print';

import React from 'react';

import { baseTheme } from '../../../../theme';

import { IPostActionButton } from '../interfaces';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.main,
      paddingBottom: '5px',
      textAlign: 'center',
      '&:hover': {
        paddingBottom: '0',
        borderBottom: 'solid 5px',
        borderColor: theme.palette.primary.main,
      },
    },
  }),
);

export default function PrintPageButton(props: IPostActionButton) {
  const classes = useStyles(baseTheme);

  const handleClick = (event: any) => {
    event.preventDefault();
    window.print();
  };

  return props.iconOnly ?
    (<PrintIcon onClick={handleClick}
      className={props.className} />) :
    (
      <Grid item container direction="column" xs={1}
        className={`${classes.root} ${props.className}`}
        onClick={handleClick}>
        <Grid item>
          <PrintIcon />
        </Grid>
        <Grid item>
          Print
        </Grid>
      </Grid>
    );
}
